// Copyright (c) 2017 Deere & Company

import DealerInvoiceFacetsContainer from './dealer-invoice-facets-container';
import Facets from '../../state/facets';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    facets: new Facets({
        ...state.claims.dealerInvoices.facets,
        dealerAccountsFacet: {
            ...state.claims.dealerInvoices.facets.dealerAccountsFacet,
            allowedDealers: state.user.details.settings.dealer.accounts.selectedAccounts
        }
    }),
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(DealerInvoiceFacetsContainer);



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/components/dealer-invoice-facets/index.js